import { apiCustom } from "./client";

const READ_TIMEOUT_MS = 25000;

function isTemporaryFailure(error: unknown): boolean {
    if ((error as { transient?: boolean })?.transient) return true;
    const status = Number((error as { status?: number })?.status);
    if (status >= 500 || status === 408) {
        return true;
    }
    if (status > 0) {
        return false;
    }

    const message = String((error as { message?: string })?.message ?? "");
    return /timeout|network error|err_network|econnaborted/i.test(message);
}

/** Repeat only idempotent Term reads after a temporary failure. */
export async function getTermRead<T>(
    path: string,
    params?: Record<string, unknown>,
    signal?: AbortSignal
): Promise<T> {
    for (let attempt = 0; attempt < 2; attempt++) {
        try {
            return await apiCustom.get<T>(path, params, { timeout: READ_TIMEOUT_MS, signal });
        } catch (error) {
            if (attempt === 1 || signal?.aborted || !isTemporaryFailure(error)) {
                throw error;
            }
        }
    }

    throw new Error("Не удалось загрузить данные");
}

export function termReadErrorMessage(error: unknown, fallback: string): string {
    return isTemporaryFailure(error)
        ? "Сервис временно не отвечает. Попробуйте обновить данные."
        : String((error as { message?: string })?.message ?? fallback);
}
